import { campaigns } from 'api';
import {
  FETCH_CAMPAIGNS,
  UPDATE_CAMPAIGNS,
  CLIENTS_BY_PARTNER,
  CLIENTS_CAMPAIGN_BY_ID,
  CAMPAIGN_FRONT_DETAIL_BY_ID,
  UPDATE_CAMPAIGN_FRONT_DETAIL,
  UPDATE_CAMPAIGN_SELECT,
  UPDATE_CAMPAIGN_SELECT_DEFAULT,
  UPDATE_CLIENTS_BY_PARTNER,
  CREATE_CLIENTS_CAMPAIGN,
  UPDATE_CLIENTS_CAMPAIGN_BY_ID,
  SET_CAMPAIGN_PROPERTY,
  SET_CAMPAIGN,
  CAMPAIGN_DELETE_BY_ID,
  UPDATE_CAMPAIGN_CLONE_DATA,
  CREATE_NEW_CAMPAIGN,
  UPDATE_CAMPAIGN_BY_ID,
  UPDATE_CLIENTS_DEFAULT_EDIT_CAMPAIGN,
  COPY_CAMPAIGN_SELECTED_DATA,
  UPDATE_LIST_FUTURE_CUSTOMER_ASSOCIATED,
  CLONE_CAMPAIGN,
  EDIT_CAMPAIGN,
  GOTO_POPUPSTORE,
  MARKETPLACE
} from 'store/actions/campaign';
import { paginationData } from 'helpers/store';

export default {
  [SET_CAMPAIGN_PROPERTY]: ({ commit }, { field, value, tabName }) =>
    commit(SET_CAMPAIGN_PROPERTY, {
      field,
      value,
      tabName
    }),
  [SET_CAMPAIGN]: ({ commit }, { field, value }) =>
    commit(SET_CAMPAIGN, {
      field,
      value
    }),

  [FETCH_CAMPAIGNS]: ({ commit }, { pagination }) =>
    new Promise((resolve, reject) => {
      campaigns
        .fetch({
          pagination
        })
        .then(
          resp => {
            const data = resp.data || [];
            commit(UPDATE_CAMPAIGNS, data);
            resolve(paginationData(resp).total);
          },
          err => {
            commit('ERROR_OCCURRED', err, {
              root: true
            });
            reject();
          }
        );
    }),

  [CLIENTS_BY_PARTNER]: ({ commit }, campaignId) =>
    new Promise((resolve, reject) => {
      campaigns.getClientsByPartner(campaignId).then(
        resp => {
          const data = resp.data;
          commit(UPDATE_CLIENTS_BY_PARTNER, data);
          resolve();
        },
        err => {
          commit('ERROR_OCCURRED', err, {
            root: true
          });
          reject();
        }
      );
    }),

  [CLIENTS_CAMPAIGN_BY_ID]: ({ commit }, { campaignId, path }) =>
    new Promise((resolve, reject) => {
      campaigns.getClientsCampaignById(campaignId).then(
        resp => {
          const data = resp.data;
          commit(UPDATE_CLIENTS_CAMPAIGN_BY_ID, {
            clients: data,
            ruta: path
          });
          resolve(resp.data);
        },
        err => {
          commit('ERROR_OCCURRED', err, {
            root: true
          });
          reject();
        }
      );
    }),

  [CAMPAIGN_FRONT_DETAIL_BY_ID]: (
    { commit },
    { campaignId, partnerId, operationId, collapse = false, flow }
  ) =>
    new Promise((resolve, reject) => {
      campaigns.campaignFrontById(campaignId, partnerId, operationId, collapse, flow).then(
        resp => {
          const data = resp.data;
          commit(UPDATE_CAMPAIGN_FRONT_DETAIL, data);
          resolve(data);
        },
        err => {
          reject(err);
        }
      );
    }),

  [CAMPAIGN_DELETE_BY_ID]: ({ commit }, campaingId) =>
    new Promise((resolve, reject) => {
      campaigns.deleteCampaign(campaingId).then(
        () => {
          resolve();
        },
        err => {
          commit('ERROR_OCCURRED', err, {
            root: true
          });
          reject();
        }
      );
    }),

  [UPDATE_CAMPAIGN_CLONE_DATA]: ({ commit }, data) => commit(UPDATE_CAMPAIGN_CLONE_DATA, data),

  [CREATE_NEW_CAMPAIGN]: ({ commit }, data) =>
    new Promise((resolve, reject) => {
      campaigns.createNewCampaign(data).then(
        resp => {
          resolve(resp.data);
        },
        err => {
          if (err.response.data.code === 409 && err.response.data.errorCode === 1) {
            reject(err.response.data);
          } else {
            commit('ERROR_OCCURRED', err, {
              root: true
            });
            reject();
          }
        }
      );
    }),

  [UPDATE_CAMPAIGN_SELECT]: ({ commit }, data) => commit(UPDATE_CAMPAIGN_SELECT, data),

  [UPDATE_CAMPAIGN_SELECT_DEFAULT]: ({ commit }, data) =>
    commit(UPDATE_CAMPAIGN_SELECT_DEFAULT, data),

  [CREATE_CLIENTS_CAMPAIGN]: ({ commit }, { campaignId, data }) =>
    new Promise((resolve, reject) => {
      campaigns.createClientsCampaign(campaignId, data).then(
        () => {
          resolve();
        },
        err => {
          commit('ERROR_OCCURRED', err, {
            root: true
          });
          reject();
        }
      );
    }),

  [UPDATE_CLIENTS_DEFAULT_EDIT_CAMPAIGN]: ({ commit }, data) =>
    commit(UPDATE_CLIENTS_DEFAULT_EDIT_CAMPAIGN, data),

  [UPDATE_CAMPAIGN_BY_ID]: (params, { campaignId, fieldsChangedSend }) =>
    new Promise((resolve, reject) => {
      campaigns.updateCampaign(campaignId, fieldsChangedSend).then(
        () => {
          resolve();
        },
        err => {
          reject(err);
        }
      );
    }),

  [COPY_CAMPAIGN_SELECTED_DATA]: ({ commit }) => commit(COPY_CAMPAIGN_SELECTED_DATA),

  [UPDATE_LIST_FUTURE_CUSTOMER_ASSOCIATED]: ({ commit }, value) =>
    commit(UPDATE_LIST_FUTURE_CUSTOMER_ASSOCIATED, value),

  [CLONE_CAMPAIGN]: ({ commit }, data) =>
    new Promise((resolve, reject) => {
      campaigns.cloneCampaign(data).then(
        res => {
          commit(UPDATE_CAMPAIGN_SELECT, res.data);
          resolve(res);
        },
        err => {
          commit('ERROR_OCCURRED', err, {
            root: true
          });
          reject();
        }
      );
    }),

  [MARKETPLACE]: ({ commit }, data) =>
    new Promise((resolve, reject) => {
      campaigns.createMarketplace(data).then(
        () => {
          resolve();
        },
        err => {
          commit('ERROR_OCCURRED', err, {
            root: true
          });
          reject();
        }
      );
    }),

  [EDIT_CAMPAIGN]: ({ commit }, { data }) =>
    new Promise((resolve, reject) => {
      campaigns.editCampaign(data).then(
        () => {
          resolve();
        },
        err => {
          commit('ERROR_OCCURRED', err, {
            root: true
          });
          reject();
        }
      );
    }),

  [GOTO_POPUPSTORE]: (params, data) => {
    const APP_POPUPSTORE_URL =
      process.env.APP_POPUPSTORE_URL.lastIndexOf('/') !== process.env.APP_POPUPSTORE_URL.length - 1
        ? `${process.env.APP_POPUPSTORE_URL}/`
        : process.env.APP_POPUPSTORE_URL;
    window.open(
      `${APP_POPUPSTORE_URL}${data.partnerId}/${data.crcGroup}?quoteId=${data.campaignId}`
    );
  }
};
